import * as Yup from 'yup'

export enum LANGUAGE {
  AFRIKAANS = 'af',
  ALBANIAN = 'sq',
  ARABIC = 'ar',
  ARABIC_EGYPT = 'ar_EG',
  ARABIC_UAE = 'ar_AE',
  ARABIC_LBN = 'ar_LB',
  ARABIC_MAR = 'ar_MA',
  ARABIC_QAT = 'ar_QA',
  AZERBAIJANI = 'az',
  BELARUSIAN = 'be_BY',
  BENGALI = 'bn',
  BENGALI_IND = 'bn_IN',
  BULGARIAN = 'bg',
  CATALAN = 'ca',
  CHINESE_CHN = 'zh_CN',
  CHINESE_HKG = 'zh_HK',
  CHINESE_TAI = 'zh_TW',
  CROATIAN = 'hr',
  CZECH = 'cs',
  DANISH = 'da',
  DARI = 'prs_AF',
  DUTCH = 'nl',
  DUTCH_BEL = 'nl_BE',
  ENGLISH = 'en',
  ENGLISH_UK = 'en_GB',
  ENGLISH_US = 'en_US',
  ENGLISH_UAE = 'en_AE',
  ENGLISH_AUS = 'en_AU',
  ENGLISH_CAN = 'en_CA',
  ENGLISH_GHA = 'en_GH',
  ENGLISH_IRL = 'en_IE',
  ENGLISH_IND = 'en_IN',
  ENGLISH_JAM = 'en_JM',
  ENGLISH_MYS = 'en_MY',
  ENGLISH_NZL = 'en_NZ',
  ENGLISH_QAT = 'en_QA',
  ENGLISH_SGP = 'en_SG',
  ENGLISH_UGA = 'en_UG',
  ENGLISH_ZAF = 'en_ZA',
  ESTONIAN = 'et',
  FILIPINO = 'fil',
  FINNISH = 'fi',
  FRENCH = 'fr',
  FRENCH_BEL = 'fr_BE',
  FRENCH_CAN = 'fr_CA',
  FRENCH_CHE = 'fr_CH',
  FRENCH_CIV = 'fr_CI',
  FRENCH_MAR = 'fr_MA',
  GEORGIAN = 'ka',
  GERMAN = 'de',
  GERMAN_AUT = 'de_AT',
  GERMAN_CHE = 'de_CH',
  GREEK = 'el',
  GUJARATI = 'gu',
  HAUSA = 'ha',
  HEBREW = 'he',
  HINDI = 'hi',
  HUNGARIAN = 'hu',
  INDONESIAN = 'id',
  IRISH = 'ga',
  ITALIAN = 'it',
  JAPANESE = 'ja',
  KANNADA = 'kn',
  KAZAKH = 'kk',
  KINYARWANDA = 'rw_RW',
  KOREAN = 'ko',
  KYRGYZ_KG = 'ky_KG',
  LAO = 'lo',
  LATVIAN = 'lv',
  LITHUANIAN = 'lt',
  MACEDONIAN = 'mk',
  MALAY = 'ms',
  MALAYALAM = 'ml',
  MARATHI = 'mr',
  NORWEGIAN = 'nb',
  PASHTO = 'ps_AF',
  PERSIAN = 'fa',
  POLISH = 'pl',
  PORTUGUESE_BR = 'pt_BR',
  PORTUGUESE_POR = 'pt_PT',
  PUNJABI = 'pa',
  ROMANIAN = 'ro',
  RUSSIAN = 'ru',
  SERBIAN = 'sr',
  SINHALA = 'si_LK',
  SLOVAK = 'sk',
  SLOVENIAN = 'sl',
  SPANISH = 'es',
  SPANISH_ARG = 'es_AR',
  SPANISH_CHL = 'es_CL',
  SPANISH_COL = 'es_CO',
  SPANISH_CRI = 'es_CR',
  SPANISH_DOM = 'es_DO',
  SPANISH_ECU = 'es_EC',
  SPANISH_HND = 'es_HN',
  SPANISH_MEX = 'es_MX',
  SPANISH_PAN = 'es_PA',
  SPANISH_PER = 'es_PE',
  SPANISH_SPA = 'es_ES',
  SPANISH_URY = 'es_UY',
  SWAHILI = 'sw',
  SWEDISH = 'sv',
  TAMIL = 'ta',
  TELUGU = 'te',
  THAI = 'th',
  TURKISH = 'tr',
  UKRAINIAN = 'uk',
  URDU = 'ur',
  UZBEK = 'uz',
  VIETNAMESE = 'vi',
  ZULU = 'zu'
}

export enum TEMPLATE_TYPE {
  SMS = 'SMS',
  WHATSAPP = 'WHATSAPP',
  INAPP = 'INAPP'
}

export enum HeaderType {
  Text = 'text',
  Media = 'media'
}

export enum ADVERTISEMENT_TYPE {
  HOMESCREEN = 'HOME_SCREEN',
  REPORTSCREEN = 'REPORT_PAGE'
}
export enum LANGUAGES {
  ENGLISH = 'ENGLISH',
  HINDI = 'HINDI',
  MARATHI = 'MARATHI'
}
export enum PLACEMENT_TYPE {
  BANNER = 'BANNER_ADS',
  INTERSTIAL = 'INTERSTITIAL_ADS',
  REWARDED = 'REWARDED_ADS',
  VIDEO = 'VIDEO_ADS'
}

export const TEMPLATE_FORM_FIELDS = {
  ID: 'id',
  CHANNELID: 'channelId',
  TEMPLATE_TYPE: 'templateType',
  TEMPLATE_NAME: 'templateName',
  TEXT_MESSAGE: 'textMessage',
  LANGUAGE: 'language',
  LANGUAGES: 'languages',
  MEDIA_FILE: 'mediaFile',
  HEADER_TYPE: 'headerType',
  HEADER_TEXT: 'headerText',
  BODY_TEXT: 'bodyText',
  DLT_ID: 'dltId',
  SENDER_ID: 'senderId',
  NAME: 'name',
  ACTIVE: 'active',
  MESSAGE: 'message',
  PLACEMENTTYPE: 'placementType',
  ADVERTISEMENTTYPE: 'type',
  REDIRECT_URL: 'redirect_url',
  DURATION: 'duration',
  VIDEO: 'video',
  IMAGE: 'image',
  CHANNELONBOARDING: 'channelOnboarding',
  REASON: 'reason'
} as const

export interface TemplateForm {
  [TEMPLATE_FORM_FIELDS.ID]: string;
  [TEMPLATE_FORM_FIELDS.CHANNELID]: string;
  [TEMPLATE_FORM_FIELDS.TEMPLATE_TYPE]: TEMPLATE_TYPE | undefined;
  [TEMPLATE_FORM_FIELDS.TEMPLATE_NAME]: string;
  [TEMPLATE_FORM_FIELDS.TEXT_MESSAGE]: string;
  [TEMPLATE_FORM_FIELDS.LANGUAGE]: LANGUAGE;
  [TEMPLATE_FORM_FIELDS.LANGUAGES]: LANGUAGES;
  [TEMPLATE_FORM_FIELDS.MEDIA_FILE]: File | null;
  [TEMPLATE_FORM_FIELDS.HEADER_TYPE]: HeaderType | undefined;
  [TEMPLATE_FORM_FIELDS.HEADER_TEXT]: string | undefined;
  [TEMPLATE_FORM_FIELDS.BODY_TEXT]: string;
  [TEMPLATE_FORM_FIELDS.DLT_ID]: string;
  [TEMPLATE_FORM_FIELDS.SENDER_ID]: string;
  [TEMPLATE_FORM_FIELDS.NAME]: string;
  [TEMPLATE_FORM_FIELDS.MESSAGE]: string;
  [TEMPLATE_FORM_FIELDS.PLACEMENTTYPE]: PLACEMENT_TYPE;
  [TEMPLATE_FORM_FIELDS.ADVERTISEMENTTYPE]: ADVERTISEMENT_TYPE;
  [TEMPLATE_FORM_FIELDS.ACTIVE]: boolean;
  [TEMPLATE_FORM_FIELDS.REDIRECT_URL]: string;
  [TEMPLATE_FORM_FIELDS.DURATION]: number | null;
  [TEMPLATE_FORM_FIELDS.VIDEO]: File | string | null;
  [TEMPLATE_FORM_FIELDS.IMAGE]: File | string | null;
  [TEMPLATE_FORM_FIELDS.REASON]: string;
  [TEMPLATE_FORM_FIELDS.CHANNELONBOARDING]: {
    id: string | number
  };
}

export const TemplateFormLabels: Record<string, string> = {
  [TEMPLATE_FORM_FIELDS.TEMPLATE_NAME]: 'Template Name',
  [TEMPLATE_FORM_FIELDS.TEXT_MESSAGE]: 'Text Message',
  [TEMPLATE_FORM_FIELDS.LANGUAGE]: 'Language',
  [TEMPLATE_FORM_FIELDS.MEDIA_FILE]: 'Media File',
  [TEMPLATE_FORM_FIELDS.HEADER_TYPE]: 'Header Type',
  [TEMPLATE_FORM_FIELDS.HEADER_TEXT]: 'Header Text',
  [TEMPLATE_FORM_FIELDS.BODY_TEXT]: 'Body Text',
  [TEMPLATE_FORM_FIELDS.DLT_ID]: 'DLT ID',
  [TEMPLATE_FORM_FIELDS.SENDER_ID]: 'Sender ID',
  [TEMPLATE_FORM_FIELDS.NAME]: 'Name',
  [TEMPLATE_FORM_FIELDS.MESSAGE]: 'Description',
  [TEMPLATE_FORM_FIELDS.PLACEMENTTYPE]: 'Placement Type',
  [TEMPLATE_FORM_FIELDS.ADVERTISEMENTTYPE]: 'Advertisement Type',
  [TEMPLATE_FORM_FIELDS.ACTIVE]: 'Active',
  [TEMPLATE_FORM_FIELDS.REASON]: 'Rejection Reason'
}

export const defaultTemplateFormValues: TemplateForm = {
  [TEMPLATE_FORM_FIELDS.ID]: '',
  [TEMPLATE_FORM_FIELDS.CHANNELID]: '',
  [TEMPLATE_FORM_FIELDS.TEMPLATE_TYPE]: TEMPLATE_TYPE.WHATSAPP,
  [TEMPLATE_FORM_FIELDS.TEMPLATE_NAME]: '',
  [TEMPLATE_FORM_FIELDS.TEXT_MESSAGE]: '',
  [TEMPLATE_FORM_FIELDS.LANGUAGE]: LANGUAGE.ENGLISH,
  [TEMPLATE_FORM_FIELDS.LANGUAGES]: LANGUAGES.ENGLISH,
  [TEMPLATE_FORM_FIELDS.MEDIA_FILE]: null,
  [TEMPLATE_FORM_FIELDS.HEADER_TYPE]: undefined,
  [TEMPLATE_FORM_FIELDS.HEADER_TEXT]: undefined,
  [TEMPLATE_FORM_FIELDS.BODY_TEXT]: '',
  [TEMPLATE_FORM_FIELDS.DLT_ID]: '',
  [TEMPLATE_FORM_FIELDS.SENDER_ID]: '',
  [TEMPLATE_FORM_FIELDS.NAME]: '',
  [TEMPLATE_FORM_FIELDS.MESSAGE]: '',
  [TEMPLATE_FORM_FIELDS.PLACEMENTTYPE]: PLACEMENT_TYPE.BANNER,
  [TEMPLATE_FORM_FIELDS.ADVERTISEMENTTYPE]: ADVERTISEMENT_TYPE.HOMESCREEN,
  [TEMPLATE_FORM_FIELDS.ACTIVE]: true,
  [TEMPLATE_FORM_FIELDS.REDIRECT_URL]: '',
  [TEMPLATE_FORM_FIELDS.DURATION]: null,
  [TEMPLATE_FORM_FIELDS.VIDEO]: null,
  [TEMPLATE_FORM_FIELDS.IMAGE]: null,
  [TEMPLATE_FORM_FIELDS.REASON]: '',
  [TEMPLATE_FORM_FIELDS.CHANNELONBOARDING]: {
    id: 0
  }
}
export const approvalValidationSchema = Yup.object({
  [TEMPLATE_FORM_FIELDS.REASON]: Yup.string()
    .required('Rejection reason is required')
    .min(5, 'Reason be at least 5 characters')
    .max(100, 'Reason be at most 100 characters')
})
export const templateValidationSchema = Yup.object().shape({
  [TEMPLATE_FORM_FIELDS.TEMPLATE_TYPE]: Yup.mixed<TEMPLATE_TYPE>()
    .oneOf(Object.values(TEMPLATE_TYPE))
    .required('Template type is required'),

  [TEMPLATE_FORM_FIELDS.CHANNELID]: Yup.string().when(
    TEMPLATE_FORM_FIELDS.TEMPLATE_TYPE,
    {
      is: (val: any) =>
        val === TEMPLATE_TYPE.WHATSAPP || val === TEMPLATE_TYPE.SMS,
      then: () => Yup.string().required('Channel is required'),
      otherwise: () => Yup.string().notRequired()
    }
  ),
  [TEMPLATE_FORM_FIELDS.CHANNELONBOARDING]: Yup.object({
    id: Yup.string().required('Channel is required')
  }).when(TEMPLATE_FORM_FIELDS.TEMPLATE_TYPE, {
    is: TEMPLATE_TYPE.INAPP,
    then: (schema) => schema,
    otherwise: () => Yup.object().nullable()
  }),
  [TEMPLATE_FORM_FIELDS.LANGUAGE]: Yup.string().when(
    TEMPLATE_FORM_FIELDS.TEMPLATE_TYPE,
    {
      is: TEMPLATE_TYPE.WHATSAPP,
      then: () =>
        Yup.string()
          .oneOf(Object.values(LANGUAGE), 'Invalid language selection')
          .required('Language is required'),
      otherwise: () => Yup.string().notRequired()
    }
  ),

  [TEMPLATE_FORM_FIELDS.TEMPLATE_NAME]: Yup.string().when(
    TEMPLATE_FORM_FIELDS.TEMPLATE_TYPE,
    {
      is: TEMPLATE_TYPE.WHATSAPP,
      then: () =>
        Yup.string()
          .matches(
            /^[a-z0-9]+$/,
            'Template name should not contain spaces or capital letters'
          )
          .min(3, 'Template name must be at least 3 characters long')
          .max(20, 'Template name should not exceed 20 characters')
          .required('Template name is required'),
      otherwise: () => Yup.string().notRequired()
    }
  ),

  [TEMPLATE_FORM_FIELDS.HEADER_TYPE]: Yup.mixed<HeaderType>().when(
    TEMPLATE_FORM_FIELDS.TEMPLATE_TYPE,
    {
      is: TEMPLATE_TYPE.WHATSAPP,
      then: () =>
        Yup.mixed<HeaderType>()
          .oneOf(Object.values(HeaderType))
          .required('Header type is required'),
      otherwise: () => Yup.mixed<HeaderType>().notRequired()
    }
  ),

  [TEMPLATE_FORM_FIELDS.BODY_TEXT]: Yup.string().when(
    TEMPLATE_FORM_FIELDS.TEMPLATE_TYPE,
    {
      is: TEMPLATE_TYPE.WHATSAPP,
      then: () =>
        Yup.string()
          .max(255, 'Body text should not exceed 255 characters')
          .required('Body text is required'),
      otherwise: () => Yup.string().notRequired()
    }
  ),

  [TEMPLATE_FORM_FIELDS.HEADER_TEXT]: Yup.string().when(
    [TEMPLATE_FORM_FIELDS.TEMPLATE_TYPE, TEMPLATE_FORM_FIELDS.HEADER_TYPE],
    {
      is: (templateType: TEMPLATE_TYPE, headerType: HeaderType) =>
        templateType === TEMPLATE_TYPE.WHATSAPP &&
        headerType === HeaderType.Text,
      then: () =>
        Yup.string()
          .max(50, 'Header text should not exceed 50 characters')
          .required('Header text is required'),
      otherwise: () => Yup.string().notRequired()
    }
  ),

  [TEMPLATE_FORM_FIELDS.MEDIA_FILE]: Yup.mixed().when(
    [TEMPLATE_FORM_FIELDS.TEMPLATE_TYPE, TEMPLATE_FORM_FIELDS.HEADER_TYPE],
    {
      is: (templateType: TEMPLATE_TYPE, headerType: HeaderType) =>
        templateType === TEMPLATE_TYPE.WHATSAPP &&
        headerType === HeaderType.Media,
      then: () => Yup.mixed().required('Media file is required'),
      otherwise: () => Yup.mixed().notRequired()
    }
  ),

  [TEMPLATE_FORM_FIELDS.NAME]: Yup.string().when(
    TEMPLATE_FORM_FIELDS.TEMPLATE_TYPE,
    {
      is: (val: any) =>
        val === TEMPLATE_TYPE.INAPP || val === TEMPLATE_TYPE.SMS,
      then: () =>
        Yup.string()
          .min(3, 'Name must be at least 3 characters long')
          .max(20, 'Name should not exceed 20 characters')
          .required('Name is required'),
      otherwise: () => Yup.string().notRequired()
    }
  ),

  [TEMPLATE_FORM_FIELDS.REDIRECT_URL]: Yup.string().when(
    TEMPLATE_FORM_FIELDS.TEMPLATE_TYPE,
    {
      is: TEMPLATE_TYPE.INAPP,
      then: () =>
        Yup.string()
          .url('Must be a valid URL')
          .required('Redirect URL is required'),
      otherwise: () => Yup.string().notRequired()
    }
  ),

  [TEMPLATE_FORM_FIELDS.DURATION]: Yup.number().when(
    TEMPLATE_FORM_FIELDS.TEMPLATE_TYPE,
    {
      is: TEMPLATE_TYPE.INAPP,
      then: () =>
        Yup.number()
          .typeError('Duration must be a number')
          .positive('Duration must be positive')
          .integer('Duration must be a whole number')
          .min(5, 'Duration must be at least 5 seconds')
          .max(30, 'Duration cannot exceed 30 seconds')
          .required('Duration is required')
          .test(
            'maxDigits',
            'Duration must be a maximum of 2 digits',
            (value) => (value ? value.toString().length <= 2 : true)
          ),
      otherwise: () => Yup.number().notRequired()
    }
  ),

  [TEMPLATE_FORM_FIELDS.ADVERTISEMENTTYPE]:
    Yup.mixed<ADVERTISEMENT_TYPE>().when(TEMPLATE_FORM_FIELDS.TEMPLATE_TYPE, {
      is: TEMPLATE_TYPE.INAPP,
      then: () =>
        Yup.mixed<ADVERTISEMENT_TYPE>()
          .oneOf(
            Object.values(ADVERTISEMENT_TYPE),
            'Invalid advertisement type'
          )
          .required('Advertisement Type is required'),
      otherwise: () => Yup.mixed<ADVERTISEMENT_TYPE>().notRequired()
    }),

  [TEMPLATE_FORM_FIELDS.PLACEMENTTYPE]: Yup.mixed<PLACEMENT_TYPE>().when(
    TEMPLATE_FORM_FIELDS.TEMPLATE_TYPE,
    {
      is: TEMPLATE_TYPE.INAPP,
      then: () =>
        Yup.mixed<PLACEMENT_TYPE>()
          .oneOf(Object.values(PLACEMENT_TYPE), 'Invalid placement type')
          .required('Placement Type is required'),
      otherwise: () => Yup.mixed<PLACEMENT_TYPE>().notRequired()
    }
  ),

  [TEMPLATE_FORM_FIELDS.MESSAGE]: Yup.string().when(
    TEMPLATE_FORM_FIELDS.TEMPLATE_TYPE,
    {
      is: (val: any) =>
        val === TEMPLATE_TYPE.INAPP || val === TEMPLATE_TYPE.SMS,
      then: () =>
        Yup.string()
          .min(3, 'Description must be at least 3 characters long')
          .max(50, 'Description should not exceed 50 characters')
          .required('Description is required.'),
      otherwise: () => Yup.string().notRequired()
    }
  ),

  [TEMPLATE_FORM_FIELDS.IMAGE]: Yup.mixed().when(
    [TEMPLATE_FORM_FIELDS.TEMPLATE_TYPE, TEMPLATE_FORM_FIELDS.VIDEO],
    {
      is: (templateType: TEMPLATE_TYPE, video: File | string | null) =>
        templateType === TEMPLATE_TYPE.INAPP && !video,
      then: () => Yup.mixed().required('Either Image or Video is required'),
      otherwise: () => Yup.mixed().nullable().notRequired()
    }
  )
})
